import React from "react";

const ReviewCard = ({ review, onVideoClick }) => {
  return (
    <div className="review-card">
      <div className="review-content">
        <p className="description">{review.description}</p>

        <div className="user-info">
          <h4>{review.fullName}</h4>

          <span>
            {review.designation} | {review.location}
          </span>
        </div>
      </div>

      <div
        className="review-image"
        onClick={() => onVideoClick(review.videoURL)}
      >
        <img
          src={review.imageThumbnil}
          alt={review.fullName}
        />
      </div>
    </div>
  );
};

export default ReviewCard;